var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: [_vm.hide ? "nominw" : ""], attrs: { id: "app" } },
    [
      _vm.isRouterAlive ? _c("router-view") : _vm._e(),
      _c("callValidPhone", { ref: "callValidPhone" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }